var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWorkforce = function SvgWorkforce(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 400 400"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M156.83 133.43s6 44.56-16.67 56.84-6.06-50.53-6.06-50.53ZM95.83 193.16S80.57 176.31 78.51 139l20.42 2.75Z",
    style: {
      fill: "#f4b42e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.2 136.13c-.72-5.78-2.35-19.48-5.34-21.68-4.56-3.3-12.9-2.52-12.9-2.52l-9.75-.78c-14.16 14.15-21.55-1.73-21.55-1.73h-1.41c-1.42 0-15.89 1.73-19.67 4.24-3 2-6.81 16.52-8.07 23.91a4.21 4.21 0 0 0 1 3.77 2.22 2.22 0 0 0 .49.3 2.81 2.81 0 0 0 .56.18l12.11 2.36a7.55 7.55 0 0 0 3.77.31c-.15 2.68-.47 5.51-.78 8.34l.13-.09c-.59 6.35-1.27 12.66-1.86 15.5-1.37 6.61-2.16 21.76-1.37 26.76.47 3.46 39.17.48 43.57.48s7.35.94 7.35-1.57c0-2-2.14-34.85-2.95-47 .85-.22 1.92-.68 2.21-.77l13-5.51c1.47-.7 1.68-2.72 1.46-4.5Z",
    style: {
      fill: "#f4b42e"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 190,
    cy: 327.15,
    rx: 172.23,
    ry: 21.23,
    style: {
      fill: "#f1f1f1"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M210.29 117.32h-27.68l-.79-30.04 35.39 3.62-7.71 28.15.79-1.73z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M243.79 313s9.13 3.3 15.89 0v9.12l-4.56 2.88s-13.84 13-16.36 13.79-13.21-1-14.16-4.25c-3.3-10.07 18.4-18.09 18.4-18.09Z",
    style: {
      fill: "#c6c6c6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.32 304.66s1.42 11.79-.16 14.31c-1.73 2.52-13.37 15.88-20.13 15.88s-11.64-2.51-11.64-5 20.92-17.61 20.92-17.61l.79-9.13ZM279.5 299.62s-1.42 11.8.16 14.32 13.36 15.88 20.13 15.88 11.64-2.51 11.64-5-20.92-17.62-20.92-17.62l-.79-9.12Z",
    style: {
      fill: "#f4b42e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.69 104.42s6.29-8.8 7.08-13.84h15.1s-.16 11.33 2.67 14.16c0 .16-12.27 14.63-24.85-.32Z",
    style: {
      fill: "#99584f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.23 183.07s4.24 61.82 5 66.85-7.55 51-7.55 51-14.16 1.73-15.89.79.79-51.91.79-51.91-7.55-45.93-9.12-46.87c-1.73-.79-5.82 45.14-5.82 48.44s-.79 52.7-.79 53.48-15.88 2.52-17.61 1.73S241 248 240 245.51c-.79-2.51 2.51-61 3.3-63.54.81-2.36 51.93 1.1 51.93 1.1Z",
    style: {
      fill: "#1d3d5c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.94 185.11s0 15.89 2.35 17.62 3.94-3 3.94-3l-3.46-14.63ZM249.14 185.11s0 15.89-2.36 17.62-3.93-3-3.93-3l3.46-14.63Z",
    style: {
      fill: "#17344c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.34 129.12v36s-11.17 36-13.06 36-1.88-16.67-1.88-16.67l7.23-20.92s-7.86-25.17-7.23-31c.47-5.93 14.94-3.41 14.94-3.41Z",
    style: {
      fill: "#ac6357"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.89 98.92s7.4 15.89 21.55 1.73l9.75.79s8.34-.79 12.9 2.51c3 2.21 4.09 16.52 5.66 22a3.42 3.42 0 0 1-1.75 4l-13 5.51c-.47.16-3 1.26-3.3.78l.78-4.56s3.31 48.92 3.31 51.44-3 1.73-7.4 1.73-43.09 3-43.57-.47c-.78-5 0-20.14 1.42-26.74 1.41-6.77 3.3-33 3.3-33l.16 8.33c-.32 1.57-3.3.95-4.72.63l-12.11-2.36a3.15 3.15 0 0 1-2.2-3.77c1.26-7.4 6.92-20.77 9.91-22.81 3.77-2.52 16.35-5.82 17.93-5.82Z",
    style: {
      fill: "#f1f1f1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.21 126.6v37.75s10.85 37.59 13.37 37.59 1.73-17.61 1.73-17.61l-5-21.55s5-25.8 4.24-31.3c-.97-5.66-14.34-4.88-14.34-4.88Z",
    style: {
      fill: "#ac6357"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.65 79.73s-3.31-17.62-1.73-22.65 20.7-7.12 34.23-4c4.33 1.44 1.73 24.54 0 24.54s-32.5 2.11-32.5 2.11Z",
    style: {
      fill: "#3a1a04"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.9 82.72s6.77 14.16 13.37 14.16c6.77 0 12.59-2.52 18.41-14.16 0 0 8.33-5 .78-8.34 0 0-4.24-10.06-13.37-10.06s-15.88 0-19.19 10.06c0-.15-10.06 2.36 0 8.34Z",
    style: {
      fill: "#ac6357"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m242.06 302.14 20.29-2.2-.15 6.29s-19.2 2.51-20.14 1.77c-.78-.83 0-5.86 0-5.86ZM274.94 296l20.44.16-.94 6.29s-19.35.32-20.13-.63.63-5.82.63-5.82Z",
    style: {
      fill: "#17344c"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.24,
    cy: 75.17,
    r: 1.26,
    style: {
      fill: "#6d3a35"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 279.34,
    cy: 75.17,
    r: 1.26,
    style: {
      fill: "#6d3a35"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 272.11,
    cy: 81.78,
    rx: 3.3,
    ry: 0.47,
    style: {
      fill: "#894a46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.57 88.54c0 .16-3.29 2.11-5 2.11-1.89 0-4.11-2.27-4.11-2.58s3.94 0 5.82 0 3.29.15 3.29.47Z",
    style: {
      fill: "#6d3a35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m290.19 101.44-9.75-.79c-14.15 14.16-21.55-1.73-21.55-1.73h-1.41c-1.42 0-15.89 1.73-19.66 4.25-3 2-6.92 17-8.18 24.38a3.15 3.15 0 0 0 2.2 3.77l12.16 2.36a7.7 7.7 0 0 0 3.78.32c.47-5.35.78-9.28.78-9.28l.16 8.33a1.44 1.44 0 0 1-.94.95c-.16 2.67-.48 5.5-.79 8.33l53.63-36.17a42.63 42.63 0 0 0-10.43-4.72Z",
    style: {
      fill: "#f1f1f1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m248.67 133.21-.16-8.34s-.31 4.09-.78 9.28c.62-.15.94-.47.94-.94Z",
    style: {
      fill: "#f1f1f1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.79 310.47s9.13 3.31 15.89 0v9.13l-4.56 2.83s-13.84 13.05-16.36 13.84-13.37-.94-14.16-4.25c-1.73-5.82 18.4-18.08 18.4-18.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.37 309.69h5.82l-.79 6.76s-8.34 11.64-10.85 11.64-5.82-2.52-5.82-2.52L244 314.41Z",
    style: {
      fill: "#f1f1f1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m233.73 323.06 10.06 3.3.79-1.57-10.07-3.3-.78 1.57zM237.82 318.97l10.06 3.3.79-1.73-9.91-3.3-.94 1.73zM242.85 313.94l8.49 3.3.79-1.73-8.49-3.31-.79 1.74z",
    style: {
      fill: "#e5e3e3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.44 308.12s-9.12 3.3-15.89 0v9.12l4.57 2.83s13.84 13.05 16.35 13.84 13.22-.94 14.16-4.25c3.3-10.06-18.4-18.08-18.4-18.08Z",
    style: {
      fill: "#c6c6c6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.44 305.6s-9.12 3.3-15.89 0v9.12l4.57 2.83s13.84 13.06 16.35 13.84 13.37-.94 14.16-4.24c1.73-5.82-18.4-18.09-18.4-18.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.71 304.66h-5.82l.79 6.76s8.33 11.64 10.85 11.64 5.82-2.52 5.82-2.52l-10.22-11.17Z",
    style: {
      fill: "#f1f1f1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m304.35 318.02-9.91 3.47-.94-1.74 10.06-3.3.79 1.57zM300.26 313.94l-10.07 3.3-.78-1.73 10.06-3.31.79 1.74zM295.23 308.9l-8.5 3.3-.78-1.72 8.49-3.31.79 1.73z",
    style: {
      fill: "#e5e3e3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.09 88.07s-3.46-12.74-1.73-17.62 14.16-11.45 28.16-8.34c18.71 4.09 9.43 27.53 7.7 27.53s-34.13-1.57-34.13-1.57Z",
    style: {
      fill: "#222"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.92 310.63s1.57 11.8-.16 14.32-13.68 15.88-20.44 15.88-12-2.51-12-5 21.24-17.46 21.24-17.46l.78-9.12ZM211.08 311.89s-1.58 11.8.15 14.31 13.69 15.89 20.45 15.89 12-2.52 12-5-21.28-17.49-21.28-17.49l-.78-9.13Z",
    style: {
      fill: "#f6ab8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.29 117.48s6.45-8.81 7.24-13.68h15.26s-.16 11.32 2.67 14.15c0 .05-12.46 14.47-25.17-.47Z",
    style: {
      fill: "#f7a27f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.34 195.81s-4.25 61.66-5 66.69-3.46 50.81-3.46 50.81 25.63 1.73 27.21.78c1.73-.78 1.88-52.85 1.88-52.85s5-44.67 6.77-45.45 6 45.93 6 49.23.79 51.59.79 52.38 24.22 2.83 26 2-4.72-58.67-3.77-61.19c.79-2.51-2.52-60.87-3.46-63.23s-52.96.83-52.96.83Z",
    style: {
      fill: "#b5a9dd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215 197.86s0 15.88 2.36 17.45c2.36 1.73 4.09-3 4.09-3l-3.62-14.63ZM177.42 197.86s0 15.88-2.36 17.45c-2.36 1.73-4.09-3-4.09-3l3.62-14.63Z",
    style: {
      fill: "#9e95c6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.73 142v35.86s-11.33 35.86-13.37 35.86-2.05-16.67-2.05-16.67l7.39-20.76s-3.3-25-2.67-30.83c.79-5.96 10.7-3.46 10.7-3.46Z",
    style: {
      fill: "#f7a27f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.65 112.13s7.55 15.89 22 1.73l9.91.79s8.5-.79 13.06 2.52c3 2.2 4.24 16.35 5.82 22 .47 1.73 2 42.31.63 42.94l-13.22-3.46c.63 3.61-3.61-29.57-2.83-29.1l-2.36-4.41s3.46 48.76 3.46 51.28-3 1.73-7.55 1.73-43.88 3-44.35-.47c-.79-5 0-20 1.57-26.58s.63-32.88.63-32.88L168.61 162c-.32 1.58 1.41 32.09 0 31.78h-10.38c-1.58-.32-1.1-27.37-.95-29.1C159.17 148.78 159 120 162 118c3.78-2.51 19.82-5.66 21.39-5.66h1.26Z",
    style: {
      fill: "#482d45"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.35 95.77s6.76 14.16 13.68 14.16 12.74-2.52 18.72-14.16c0 0 8.49-5 .79-8.33 0 0-4.25-17-13.69-17s-16.2 7.08-19.66 17c.16.15-10.06 2.56.16 8.33Z",
    style: {
      fill: "#f6ab8b"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190,
    cy: 88.38,
    r: 1.26,
    style: {
      fill: "#6d3a35"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 205.26,
    cy: 88.38,
    r: 1.26,
    style: {
      fill: "#6d3a35"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 198.02,
    cy: 94.99,
    rx: 3.46,
    ry: 0.47,
    style: {
      fill: "#894a46",
      isolation: "isolate",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.48 101.75a4.74 4.74 0 0 1-3.48 2c-1.89 0-6-2.21-6-2.52 0-.16 4.09 0 6 0s3.48.21 3.48.52Z",
    style: {
      fill: "#6d3a35",
      isolation: "isolate",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m182.61 117.32-7.87-15.57S173 72 179.46 68.88s33.82-2.36 37.44 2 2.83 22 2.83 29.1l-9.6 17.3-.47-30.51-.16-11.33-25.16 7.87Z",
    style: {
      fill: "#222"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.19 321.64s10.38 9.28 15.26 10.07c4.87.94 10.06-3.15 10.06-3.15s11.64 6.77 11.64 7.55-3.93 7.87-14.78 7.08-22.81-18.56-22.81-18.56ZM183.71 320.7s-10.38 9.28-15.26 10.07-10.07-3.15-10.07-3.15-11.63 6.76-11.63 7.55 3.93 7.86 14.78 7.08c10.85-.95 22.81-18.56 22.81-18.56Z",
    style: {
      fill: "#191919"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.66 190.46s3.94 19.66 4.57 22 .47 6.92-1 6.77c-.94-.16-1.26-4.88-1.26-4.88s-3 11.8-4.71 12.9-.79-6.29-.79-6.29-1.42 4.24-2.67 4.09c.47 0 2.67-15.73 2.51-15 0 0-1.73 11.8-5.19 11.49-1.26-.16 1.89-11.64 3.78-14.79s-3.31-15.41-3.31-15.41 4.14-3.08 8.07-.88Z",
    style: {
      fill: "#f7ab8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.54 80.05s-3.14 14.31 1.89 13.36c10.07-1.88 7.75-18.73 6.29-22.65-1.73-4.66-12.27-12-19.66-11-7.55 1-17.14 4.09-17.93 9.13s-6.61 5.19-3.93 12.58c2.67 7.55.16 13.37 2.67 14.94s6.92 13.22 4.41 9.13 6.6-4.25 6.6-7.71c0-3.3-3.61-20.92-3.61-20.92Z",
    style: {
      fill: "#ead199"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.22 113.23s5.82-8.18 6.45-12.89l14.16-.16s0 10.38 2.67 13c0 .21-11.33 13.89-23.28.05Z",
    style: {
      fill: "#e89e85"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.1 305.91s8.65 3 14.94-.31l.16 8.49-4.2 2.68S94.1 329 91.74 329.82s-12.42-.82-13.52-3.62c-3.31-9.28 17-17 17-17Z",
    style: {
      fill: "#d33352"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.31 292.54s1.1 16.2-.47 18.56-12.43 14.79-18.72 14.95-11-2.21-11.17-4.41c0-2.36 19.51-16.51 19.51-16.51l.63-13.06ZM129.6 286.88s-1.41 17 .32 19.35 12.89 14.47 19.18 14.31 11-2.52 11-4.87-20-15.89-20-15.89l-.94-13.06Z",
    style: {
      fill: "#f7ab8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.05 185.11s4.87 54.43 5.66 58.83-6.45 45-6.45 45-13.37 1.73-14.94.94 0-45.61 0-45.61-7.71-40.43-9.28-41.06-4.88 39.79-4.88 42.79v47.18c0 .79-14.94 2.52-16.51 1.73s-3.94-51.43-4.88-53.63.22-53.85.84-56c.95-2.42 50.44-.17 50.44-.17Z",
    style: {
      fill: "#56d0e8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.1 303.55s8.65 3 14.94-.31l.16 8.49-4.2 2.68s-12.9 12.27-15.26 13-12.58-.63-13.52-3.62c-1.73-5.34 17-17 17-17Z",
    style: {
      fill: "#f23a54"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m97.51 302.77 5.51-.16-.63 6.13s-7.71 10.86-10.07 11-5.5-2.21-5.5-2.21l9.59-10.38Z",
    style: {
      fill: "#d33352"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m86.82 315.35 9.43 2.83.79-1.57-9.59-2.83-.63 1.57zM90.59 311.42l9.6 2.83.78-1.57-9.59-2.83-.79 1.57zM95.31 306.7l8.02 2.99.63-1.57-8.02-2.99-.63 1.57z",
    style: {
      fill: "#e5e3e3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.76 300.57s-8.65 3.14-14.95.31l.16 8.49 4.25 2.52s13.21 11.8 15.73 12.58c2.36.79 12.42-1.1 13.37-4.09 3-9.28-17.62-16.51-17.62-16.51Z",
    style: {
      fill: "#d33352"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.6 298.21s-8.65 3.14-14.94.31l.15 8.49 4.25 2.52s13.21 11.8 15.73 12.58c2.36.79 12.58-1.1 13.37-4.09 1.42-5.34-17.62-16.51-17.62-16.51Z",
    style: {
      fill: "#f23a54"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m142 297.42-5.51.16.95 6.13s8 10.7 10.38 10.7 5.5-2.36 5.5-2.36L143.44 302Z",
    style: {
      fill: "#d33352"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m153.35 309.53-9.44 3.3-.78-1.57 9.43-3.14.79 1.41zM149.26 305.76l-9.28 3.3-.94-1.57 9.43-3.15.79 1.42zM144.54 301.19l-8.02 3.31-.63-1.57 7.87-3.15.78 1.41z",
    style: {
      fill: "#e5e3e3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104 90.11s6.45 13.06 12.74 12.9 11.8-2.52 17.15-13.37c0 0 7.86-4.72.63-7.71 0 0-4.09-9.12-12.74-9.12s-15 .31-17.93 9.59c.15 0-9.33 2.52.15 7.71Z",
    style: {
      fill: "#f7ab8b"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 111.84,
    cy: 83.18,
    rx: 1.26,
    ry: 1.1,
    style: {
      fill: "#6d3a35"
    },
    transform: "translate(-1.32 1.81)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 126.01,
    cy: 82.86,
    rx: 1.26,
    ry: 1.1,
    style: {
      fill: "#6d3a35"
    },
    transform: "rotate(-.92 125.767 82.597)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 119.39,
    cy: 89.16,
    rx: 3.15,
    ry: 0.31,
    style: {
      fill: "#894a46",
      isolation: "isolate",
      opacity: 0.5
    },
    transform: "rotate(-.92 119.484 89.398)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.68 95.3c0 .16-2.74 2.41-4.47 2.57S114 95.3 114 95.14s3.77 0 5.5-.15a8.54 8.54 0 0 1 3.18.31Z",
    style: {
      fill: "#6d3a35",
      isolation: "isolate",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.22 181.34s48.25-4.4 49.82-5.5v-3.61l-49.82 5.65ZM93.67 172.23s45.92-4.84 47.65-5.78v-3.61l-46.93 5.78ZM95.11 162.47s44.81-5.2 46.21-6l-.38-2.68-45.83 6.3Z",
    style: {
      fill: "#dd9d2a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.58 162.84s-.76-4.8-3.78-7.09c0 0-1.58-.13-2.3 4.2 0 0-5.57-1.14-6.5-5.77s-2.89-6.5-8.66-12.28c-7-6.94-7-10.24-7.82-17s-.93-21.66 18.24-24.69l5.46 2s-.84 22.71 5.36 24.34c0 0-.86 2.43-2.75 2 0 0 8.22 4.55 9.3 12.9s-2.64 19.23-6.55 21.39Z",
    style: {
      fill: "#ead199"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.28 95.75s7.55 2.36 7.55 4.24-.16 3.15-.94 4.25-10.07-3.78-9.76-4.56 1.26-4.41 3.15-3.93Z",
    style: {
      fill: "#f23a54"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.76 185.22s-48.81-1.51-50.54-.88v5.94Z",
    style: {
      fill: "#4abfce"
    }
  })));
};
export default SvgWorkforce;